export const GTM = {
   successCoopPraev: (krankenkasse: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'success_coop_praev',
      krankenkasse,
    });
  },
};
